"use client";

import * as React from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/tooltip/tooltip";
import styles from "./FeatureDneMarker.module.css";

const TOOLTIP_MESSAGE = "Feature Does Not Exist - Must Remove or Update";

interface FeatureDneMarkerProps {
  /** The matched substring (preserves the author's original casing). */
  children: React.ReactNode;
}

/**
 * Wraps a stretch of text in a red highlight + tooltip so QA can spot
 * placeholder copy at a glance. Triggered automatically by
 * `highlightFeatureDne` whenever the literal "FEATURE DNE" (any casing)
 * appears in user-facing text. Radix tooltip handles hover + keyboard
 * focus, satisfying both "hover or click" inputs accessibly.
 */
export default function FeatureDneMarker({ children }: FeatureDneMarkerProps) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={styles.marker} tabIndex={0}>
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className={styles.tooltipContent}>
          {TOOLTIP_MESSAGE}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
